var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'cellBox',
    this.isStriked?'striked':'',
    this.shakeEffect?'shaking':'',
    this.dummyStrike?'dummyStrike':'',
    _vm.strikedPlayerIndex ? 'strikedPlayer' + _vm.strikedPlayerIndex : ''
  ],on:{"click":function($event){return _vm.play(_vm.cellData.number)}}},[_c('div',{class:['number',(_vm.isMyturn && !_vm.isStriked)?'turn':'']},[_vm._v(_vm._s(_vm.cellData.number))])])}
var staticRenderFns = []

export { render, staticRenderFns }